import { Users } from 'lucide-react';

interface Coach {
  id: string;
  email: string;
}

interface CoachesSectionProps {
  coaches: Coach[];
}

export function CoachesSection({ coaches }: CoachesSectionProps) {
  return (
    <div className="bg-card rounded-lg shadow p-6">
      <div className="flex items-center gap-2 mb-4">
        <Users className="w-5 h-5 text-muted-foreground" />
        <h2 className="font-semibold">Assigned Coaches</h2>
        <span className="text-sm text-muted-foreground">({coaches.length})</span>
      </div>
      {coaches.length === 0 ? (
        <p className="text-muted-foreground text-sm">No coaches assigned</p>
      ) : (
        <ul className="space-y-2">
          {coaches.map((coach) => (
            <li key={coach.id} className="flex items-center gap-2 text-sm">
              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                <span className="text-primary font-medium text-xs">
                  {coach.email[0].toUpperCase()}
                </span>
              </div>
              <span>{coach.email}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
